import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import React from "react";
import { Redirect, RouteComponentProps, Switch } from "react-router-dom";

import {
  wsmFitmentApplicationListPath,
  wsmFitmentAxisAddPath,
  wsmFitmentAxisListPath,
  wsmFitmentAxisPath,
  wsmFitmentQualifierAddPath,
  wsmFitmentQualifierListPath,
  wsmFitmentQualifierPath,
  wsmFitmentSchemaAddPath,
  wsmFitmentSchemaListPath,
  wsmFitmentSchemaPath,
  wsmFitmentSectionUrlName,
} from "./urls";
import WsmFitmentApplicationsView from "./views/WsmFitmentApplications";
import WsmFitmentAxisCreateView from "./views/WsmFitmentAxisCreate";
import WsmFitmentAxisDetailsView from "./views/WsmFitmentAxisDetails";
import WsmFitmentAxisListView from "./views/WsmFitmentAxisList";
import WsmFitmentQualifierCreateView from "./views/WsmFitmentQualifierCreate";
import WsmFitmentQualifierDetailsView from "./views/WsmFitmentQualifierDetails";
import WsmFitmentQualifierListView from "./views/WsmFitmentQualifierList";
import WsmFitmentSchemaCreateView from "./views/WsmFitmentSchemaCreate";
import WsmFitmentSchemaDetailsView from "./views/WsmFitmentSchemaDetails";
import WsmFitmentSchemaListView from "./views/WsmFitmentSchemaList";

const SchemaDetails = ({ match }: RouteComponentProps<{ id: string }>) => (
  <WsmFitmentSchemaDetailsView id={decodeURIComponent(match.params.id)} />
);
const Applications = ({ match }: RouteComponentProps<{ id: string }>) => (
  <WsmFitmentApplicationsView schemaId={decodeURIComponent(match.params.id)} />
);
const AxisDetails = ({ match }: RouteComponentProps<{ id: string }>) => (
  <WsmFitmentAxisDetailsView id={decodeURIComponent(match.params.id)} />
);
const QualifierDetails = ({ match }: RouteComponentProps<{ id: string }>) => (
  <WsmFitmentQualifierDetailsView id={decodeURIComponent(match.params.id)} />
);

// Each "add" route comes before its :id route, which would otherwise match it.
const Component = () => (
  <>
    <WindowTitle title="Fitment Management" />
    <Switch>
      <Route exact path={wsmFitmentSchemaAddPath} component={WsmFitmentSchemaCreateView} />
      <Route exact path={wsmFitmentSchemaListPath} component={WsmFitmentSchemaListView} />
      <Route exact path={wsmFitmentApplicationListPath(":id")} component={Applications} />
      <Route exact path={wsmFitmentSchemaPath(":id")} component={SchemaDetails} />
      <Route exact path={wsmFitmentAxisAddPath} component={WsmFitmentAxisCreateView} />
      <Route exact path={wsmFitmentAxisListPath} component={WsmFitmentAxisListView} />
      <Route exact path={wsmFitmentAxisPath(":id")} component={AxisDetails} />
      <Route exact path={wsmFitmentQualifierAddPath} component={WsmFitmentQualifierCreateView} />
      <Route exact path={wsmFitmentQualifierListPath} component={WsmFitmentQualifierListView} />
      <Route exact path={wsmFitmentQualifierPath(":id")} component={QualifierDetails} />
      <Redirect from={wsmFitmentSectionUrlName} to={wsmFitmentSchemaListPath} />
    </Switch>
  </>
);

export default Component;
